import React, { useState, useEffect } from "react";
import "./App.css";
import "./Responsive.css";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import BranSelfIndex from '../src/Components/brandselfauditkit/SelfIndex';
import BybMainIndex from '../src/BybMainIndex';
import PrivacyPolicyPage from "../src/Components/BybMainPage/PrivacyPolicyPage";
import TermsConditionPage from "../src/Components/BybMainPage/TermsConditionPage";
import ShippingPage from "../src/Components/BybMainPage/ShippingPage";
import CancleDeliveryPage from "../src/Components/BybMainPage/CancleDeliveryPage";
import ClientLogin from "../src/pages/client/LoginPage";


// Admin Pages

import AdminLoginPage from '../src/pages/admin/AdminLoginPage';
import AdminForgotPasswordPage from '../src/pages/admin/AdminForgotPasswordPage';
import AdminResetPasswordPage from '../src/pages/admin/AdminResetPasswordPage';
import AdminOverview from '../src/pages/admin/AdminOverviewPage';
import AdminSettingPage from '../src/pages/admin/AdminSettingPage';
import AdminNewInviteFormPage from '../src/pages/admin/AdminNewInviteFormPage';
import AdminSurveysPage from '../src/pages/admin/AdminSurveysPage';
import AdminEmployeeFormPage from '../src/pages/admin/AdminEmployeeFormPage';
import AdminCustomerFormPage from '../src/pages/admin/AdminCustomerFormPage';
import AdminPartnerFormPage from '../src/pages/admin/AdminPartnerFormPage';
import AdminInvestorFormPage from '../src/pages/admin/AdminInvestorFormPage';
import AdminCategoriesPage from '../src/pages/admin/AdminCategoriesPage';
import AdminBlogPage from '../src/pages/admin/AdminBlogPage';
import AdminTagsPage from '../src/pages/admin/AdminTagsPage';
import AdminUserManagementPage from '../src/pages/admin/AdminUserManagementPage';
import AdminSubscribers from '../src/pages/admin/AdminSubscribers';
import MetaTagsPage from '../src/pages/admin/MetaTagsPage';
import MetaTagsDetail from '../src/pages/admin/MetaTagsDetail';
import BlogMetaTagsDetail from '../src/pages/admin/BlogMetaTagsDetail';
import AdminBrandAudit from '../src/pages/admin/AdminBrandAudit';
import QuickBrandLeadsPage from './pages/QuickBrandLeadsPage';



// Client Pages
// import LoginPage from './pages/LoginPage';
import ClientForgotPasswordPage from '../src/pages/client/ClientForgotPasswordPage';
import ClientResetPasswordPage from '../src/pages/client/ClientResetPasswordPage';
import ClientOverviewPage from '../src/pages/client/ClientOverviewPage';
import ClientSettingPage from '../src/pages/client/ClientSettingPage';
import ClientNewInviteFormPage from '../src/pages/client/ClientNewInviteFormPage';
import ClientSurveysPage from '../src/pages/client/ClientSurveysPage';
import ClientEmployeeFormPage from '../src/pages/client/ClientEmployeeFormPage';
import ClientCustomerFormPage from '../src/pages/client/ClientCustomerFormPage';
import ClientPartnerFormPage from '../src/pages/client/ClientPartnerFormPage';
import ClientInvestorFormPage from '../src/pages/client/ClientInvestorFormPage';
import ClientCategoriesPage from '../src/pages/client/ClientCategoriesPage';
import ClientSurveyform from '../src/pages/client/ClientCommonPopupPage';
import ClientFourZeroFour from '../src/pages/client/ClientFourZeroFour';
import ClientTagsPage from '../src/pages/client/ClientTagsPage';
import ClientBlogPage from '../src/pages/client/ClientBlogPage';
import ComingSoon from "./pages/ComingSoon"
import BrandAuditToolPage from "./pages/BrandAuditToolPage";
import BrandGlossaryPage from "./pages/BrandGlossaryPage";
import PressMediaKitPage from "./pages/PressMediaKitPage";
import DiscoveryCallPage from "./pages/discoverycall/DiscoveryCallPage";
import BrandWorkbookLandingPage from "./pages/brandworkbooklanding/BrandWorkbookLandingPage";

//E-magazine
import CategoryPage from "./pages/emagazine/CategoryPage";
import BlogDetailPage from "./pages/emagazine/BlogDetailPage";
import BlogDetailPageDemo from "./pages/emagazine/BlogDetailPageDemo";
import AuthorProfilePage from "./pages/emagazine/AuthorProfilePage";
import { buildEmagazineCategoryPath, resolveEmagazineCategoryParam } from "./pages/emagazine/emagazineApi";


import { YearContext } from "./Components/CopyrightContext";
import { ThemeContext } from "./pages/emagazine/ThemeContext";
import LearningLoginPage from "./pages/byblearning/LearningLoginPage";
import LearningSignupPage from "./pages/byblearning/LearningSignupPage";
import LeariningForgotPassword from "./Components/Learning/Login/LeariningForgotPassword";
import DashboardHomePage from "./pages/byblearning/LearningHomePage";
import LearningUserDetail from "./Components/Learning/LearningUserDetail";
import LearningUserDetailPage from "./pages/byblearning/LearningUserDetailPage";
import LearningDetail from "./Components/Learning/LearningDetail";
import ProtectedRoute from "./Components/Learning/ProtectedRoute";
import LearningHomePage from "./pages/byblearning/LearningHomePage";
import LearningDashboardPage from "./pages/byblearning/LearningDashboardPage";
import SecureVideoPlayerPage from "./pages/byblearning/SecureVideoPlayerPage";
import LessonDetail from "./Components/Learning/Lesson/LessonDetail";
import PurchasedRoute from "./Components/Learning/PurchasedRoute";
import LearningNewBybPage from "./pages/byblearning/LearningNewBybPage";
import BybCompleteBrandPage from "./pages/bybcompletebrand/BybCompleteBrandPage";
import WhatsAppChatbotButton from "./Components/Common/WhatsAppChatbotButton/WhatsAppChatbotButton";
import RouteSeoController from "./Components/Common/Seo/RouteSeoController";
import MetaPixelPageView from "./Components/Common/MetaPixelPageView";

// import TestAdmin from "./pages/admin/TestAdmin";

const BYB_REFERRER_PATTERN = /^https?:\/\/([^/]+\.)?brewyourbrand\.in(\/|$)/i;
const TAGMANGO_LANDING_URL = "https://course.brewyourbrand.in/services/learning";
const HASH_ROUTE_PATTERN = /^#\/.+/;

const HASH_CLEAN_ROUTE_PREFIXES = [
  "/brandselfauditkit",
  "/privacy-policy",
  "/terms-and-conditions",
  "/term-condition",
  "/shipping-delivery",
  "/cancellation-refund",
  "/e-magazine",
];

function hasClientRouteHash() {
  return HASH_ROUTE_PATTERN.test(window.location.hash);
}

function HashRouteRedirect() {
  useEffect(() => {
    if (!hasClientRouteHash()) {
      return;
    }

    let hashUrl;

    try {
      hashUrl = new URL(window.location.hash.slice(1), window.location.origin);
    } catch (error) {
      return;
    }

    const cleanPath = hashUrl.pathname.replace(/\/index\.html$/i, "/");
    const redirectPath = cleanPath === "/term-condition" ? "/terms-and-conditions" : cleanPath;
    const shouldRedirect = HASH_CLEAN_ROUTE_PREFIXES.some((prefix) =>
      cleanPath === prefix || cleanPath.startsWith(`${prefix}/`)
    );

    if (shouldRedirect) {
      window.location.replace(`${redirectPath}${hashUrl.search}`);
    }
  }, []);

  return null;
}

function LegacyEmagazineCategoryRedirect() {
  const { categoryId } = useParams();
  const category = resolveEmagazineCategoryParam(categoryId || "");

  return <Navigate to={buildEmagazineCategoryPath(category)} replace />;
}

function LegacyTermsRedirect() {
  return <Navigate to="/terms-and-conditions" replace />;
}

function UnusedEmagazinePageRedirect() {
  return <Navigate to="/404" replace />;
}

function NotFoundRedirect() {
  const location = useLocation();

  if (location.pathname === "/404") {
    return <ClientFourZeroFour />;
  }

  return <Navigate to="/404" replace />;
}

function HomeRoute() {
  const [showHome, setShowHome] = useState(false);

  useEffect(() => {
    const isProductionDomain = /(^|\.)brewyourbrand\.in$/i.test(window.location.hostname);
    const cameFromBybPage = BYB_REFERRER_PATTERN.test(document.referrer);

    if (isProductionDomain && !cameFromBybPage && !hasClientRouteHash()) {
      window.location.replace(TAGMANGO_LANDING_URL + window.location.search + window.location.hash);
      return;
    }

    setShowHome(true);
  }, []);

  return showHome ? <BybMainIndex /> : null;
}

function App() {
  return (
    <>
  <ThemeContext>
    <YearContext>
        <Router>
          <HashRouteRedirect />
          <MetaPixelPageView />
          <RouteSeoController />
          <WhatsAppChatbotButton />
          <Routes>

      {/* <Route path="learning" element={<LearningHomePage/>}></Route>
      <Route path="phpdashboard" element={<SecureVideoPlayerPage/>}></Route>
      <Route path="login" element={<LearningLoginPage/>}></Route>
      <Route path="signup" element={<LearningSignupPage/>}></Route>
      <Route path="forgot-password" element={<LeariningForgotPassword/>}></Route>
        <Route path="/course/:slug" element={<LearningDetail />} />
      <Route path="/course/:slug/lesson/:lessonId" element={<LessonDetail  />} />
      
      <Route path="new_byb" element={<LearningNewBybPage/>}></Route>

    <Route path="/learning/dashboard/:slug" element={<LearningDashboardPage />}/>

    <Route path="/byb-complete-brand" element={<BybCompleteBrandPage />}/> */}

      {/* <Route
    path="/learning/dashboard/:slug"
    element={
      <ProtectedRoute>
        <PurchasedRoute>
          <LearningDashboardPage />
        </PurchasedRoute>
      </ProtectedRoute>
    }
  /> */}

{/* <Route path="/learning/dashboard" element={<Navigate to="/learning" replace />} /> */}

    {/* user detail information */}
      {/* <Route path="user-details" element={<LearningUserDetailPage/>}></Route> */}

    {/* <Route path="/brandaudittool" element={<BrandAuditToolPage/>} /> */}

    {/*Admin  */}
           <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPasswordPage />} />
            <Route path="/admin/reset-password" element={<AdminResetPasswordPage />} />
            <Route path="/admin/overview" element={<AdminOverview/>} />
            <Route path="/admin/surveys" element={<AdminSurveysPage />} />
            <Route path="/admin/customer-form" element={<AdminCustomerFormPage />} />
            <Route path="/admin/employee-form" element={<AdminEmployeeFormPage />} />
            <Route path="/admin/partner-form" element={<AdminPartnerFormPage />} />
            <Route path="/admin/investor-form" element={<AdminInvestorFormPage />} />
            <Route path='/admin/setting' element={<AdminSettingPage />} />
            <Route path='/admin/categories' element={<AdminCategoriesPage />} />
            <Route path='/admin/tags' element={<AdminTagsPage />} />
            <Route path='/admin/blog' element={<AdminBlogPage />} />
            <Route path='/admin/subscribers' element={<AdminSubscribers />} />
            <Route path='/admin/user-management' element={<AdminUserManagementPage />} />
            <Route path='/admin/brand-audit' element={<AdminBrandAudit />} />
            <Route path='/quick-brand-leads' element={<QuickBrandLeadsPage />} />
            <Route path="/admin/new-user" element={<AdminNewInviteFormPage />} />
            <Route path="/admin/meta-tags" element={<MetaTagsPage />} />
            <Route path="/admin/meta-tags/:Id" element={<MetaTagsDetail />} />
            <Route path="/admin/blog-meta-tags/:Id" element={<BlogMetaTagsDetail />} />

                
              {/* Client */}
                  <Route path="/client" element={<ClientLogin/>} />
                    <Route path="/client/forgot-password" element={<ClientForgotPasswordPage />} />
                    <Route path="/client/reset-password" element={<ClientResetPasswordPage />} />
                    <Route path="/client/overview" element={<ClientOverviewPage/>} />
                    <Route path="/client/surveys" element={<ClientSurveysPage />} />
                    <Route path="/client/customer-form" element={<ClientCustomerFormPage />} />
                    <Route path="/client/employee-form" element={<ClientEmployeeFormPage />} />
                    <Route path="/client/partner-form" element={<ClientPartnerFormPage />} />
                    <Route path="/client/investor-form" element={<ClientInvestorFormPage />} />
                    <Route path='/client/setting' element={<ClientSettingPage />} />
                    <Route path='/client/new-user' element={<ClientNewInviteFormPage />} />
                    <Route path='/client/categories' element={<ClientCategoriesPage />} />
                    <Route path='/client/tags' element={<ClientTagsPage />} />
                    <Route path='/client/blog' element={<ClientBlogPage />} />
                    <Route path='/404' element={<ClientFourZeroFour />} />
                    <Route path="/:surveyId" element={<ClientSurveyform />} />

                <Route path="/" element={<HomeRoute/>} />
                <Route path="/comingsoon" element={<ComingSoon/>} />
                <Route path="/brandselfauditkit" element={<BranSelfIndex/>} />
                <Route path="/brand-glossary" element={<BrandGlossaryPage />} />
                <Route path="/press" element={<PressMediaKitPage />} />
                <Route path="/discovery-call" element={<DiscoveryCallPage />} />
                <Route path="/discovery" element={<DiscoveryCallPage />} />
                <Route path="/brand-workbook" element={<BrandWorkbookLandingPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/term-condition" element={<LegacyTermsRedirect />} />
                <Route path="/terms-and-conditions" element={<TermsConditionPage />} />
                <Route path="/shipping-delivery" element={<ShippingPage />} />
                <Route path="/cancellation-refund" element={<CancleDeliveryPage />} />
                <Route path="/author/:authorSlug" element={<AuthorProfilePage />} />
                <Route path="/e-magazine/category/:categoryId" element={<LegacyEmagazineCategoryRedirect />} />
                <Route path="/e-magazine/about-us" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/about-us/" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/about-us.html" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/contact-us" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/contact-us/" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/contact-us.html" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/faq" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/faq/" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/faq.html" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/privacy-policy" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/privacy-policy/" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/privacy-policy.html" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/terms-and-conditions" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/terms-and-conditions/" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/terms-and-conditions.html" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/terms-and-condition.html" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/terms&condition.html" element={<UnusedEmagazinePageRedirect />} />
                <Route path="/e-magazine/:categoryId" element={<CategoryPage />} />
                <Route path="/e-magazine/:categoryId/:blogId" element={<BlogDetailPage />} />
                <Route path="/e-magazine/demo/:categoryId/:blogId" element={<BlogDetailPageDemo />} />
                <Route path="*" element={<NotFoundRedirect />} />
          </Routes>

          </Router>
          </YearContext>
          </ThemeContext>

  </>
  );
}

export default App;
